<template>
    <Index></Index>
		<IntroOverlay></IntroOverlay>
</template>

<script>
import { inject } from "vue";

import Index from '@/components/pages/index.vue'
import IntroOverlay from '@/components/particle/IntroOverlay.vue'

export default {
  name: 'Home',
  components: {
    Index,
		IntroOverlay
  },
  setup() {
    const store = inject("store");
    return {
      state: store.state
    };
  },	
}
</script>

